import { createFileRoute } from '@tanstack/react-router';
import OrdinaryGraphOnline from '../../../components/Graphs/OrdinaryGraph';
import { BATTERY_VOLTAGE } from '../../../components/OnlinePanel/Widgets/constants';

export const Route = createFileRoute('/_authenticated/graphs/battery-voltage/$vehicleId')({
  beforeLoad: ({ context }) => {
    return {
      ...context,
      documentTitle: {
        main: 'infoWindow.data.voltage',
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: BatteryVoltageGraphRoute,
});

function BatteryVoltageGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <OrdinaryGraphOnline vehicleId={Number(vehicleId)} name={BATTERY_VOLTAGE} isPage />;
}
